import React from 'react';
import { Icon } from 'rsuite';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import helper from '../../../../../helpers/validaciones';
import { doGetCompanyData } from './actions';
import LoadingOverlay from '../../../../Shared/LoadingOverlay';
import PagedList from '../../../../Shared/PagedList';
import CardTabs from '../../../../Shared/CardTabs';
import { getLists } from '../../../../Global/actions';
import SucursalDetails from './sucursalDetails';
import { push } from 'connected-react-router';
import { paths } from '../../../../../config/routes';
import './style.scss';

class DatosEmpresa extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            index: 0,
            selectedSucursal: {},
            alertVisible: true,
        };
    }

    componentDidMount = () => {
        const lista = {
            listaRegion: true,
        };
        this.props.dispatch(getLists(lista));
        if (this.props.companyId != null) {
            this.props.dispatch(doGetCompanyData(this.props.companyId));
        }
    };

    componentDidUpdate = (prevProps) => {
        if (this.props.companyId !== prevProps.companyId && this.props.companyId !== null) {
            this.props.dispatch(doGetCompanyData(this.props.companyId));
        }
        if (prevProps.companyId !== this.props.companyId) {
            this.props.dispatch(push(paths.root));
        }
    };

    hideAlert = () => this.setState({ alertVisible: false });

    getCompanyData = () => {
        const Data = {};
        const company = {
            ...this.props.companyDetails,
        };

        let representante = {};
        if (this.props.companyDetails) {
            representante = {
                ...company.representanteLegal,
            };
        }
        Data.className = 'col-12';
        Data.background = '#00B2A9';
        Data.LettersCircle = `${helper.getFirstLetter(this.props.companyName)}`;
        Data.Title = this.props.companyName;
        Data.Tabs = [
            {
                text: 'Info de la empresa',
                tooltipo: { icono: '', text: '' },
                hasSeccion: false,
                idTab: 'tab1',
                data: [
                    {
                        label: 'Rut',
                        value: helper.formatRut(this.props.companyId, { showDots: true, showHyphen: true }),
                    },
                    {
                        label: 'Dirección', value: company.direccionEmpresa || 'Sin datos',
                    },
                    {
                        label: 'Mail', value: company.emailContacto || 'Sin datos',
                    },
                    {
                        label: 'teléfono fijo', value: company.telefonoContacto || 'Sin datos',
                    },
                ],
            },
            {
                text: 'Representante legal',
                tooltipo: { icono: '', text: '' },
                hasSeccion: false,
                idTab: 'tab2',
                data: [
                    { label: 'Nombre', value: representante.nombrerepresentanteLegal || 'Sin datos' },
                    {
                        label: 'Rut',
                        value: representante.rutRepresentanteLegal ? helper.formatRut(representante.rutRepresentanteLegal, {
                            showDots: true,
                            showHyphen: true,
                        }) : 'Sin datos',
                    },
                    {
                        label: 'Email', value: representante.emailrepresentanteLegal || 'Sin datos',
                    },
                    {
                        label: 'Direccion', value: representante.direccionRepresentanteLegal || 'Sin datos',
                    },
                    {
                        label: 'Teléfono', value: representante.telefonorepLegal || 'Sin datos',
                    },
                ],
            },
        ];

        return [
            Data,
        ];
    };

    handleSucursalDetails = (e) => {
        this.setState({ selectedSucursal: e.data, index: 1 });
    };

    render() {
        return (
            <div className='row zero user-card-info'>
                {this.props.isLoading && <LoadingOverlay />}
                <div className='col-12 zero-left card-empresas'>
                    {/* NOTE: FEATURE LINK REPRESENTANTE LEGAL */}
                    {this.props.isAdmin && this.state.alertVisible && (
                        <div class='representante-legal-alert alert alert-warning alert-dismissible' role='alert'
                             style={{ display: 'flex' }}>
                            <Icon icon='exclamation-circle' size='3x' style={{ color: '#F7E102' }} />
                            <strong>
                                Si eres el Representante Legal de tu organización y quieres actualizar tus datos de
                                contacto, &nbsp;<a href='https://achs.az1.qualtrics.com/jfe/form/SV_0la5uz4sXeDaxqC'
                                                   target='_blank'>Ingresa aquí</a>

                            </strong>
                            <button type='button' class='close' data-dismiss='alert' aria-label='Close'
                                    onClick={this.hideAlert}>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                    )}

                    <CardTabs userData={this.getCompanyData()} />
                    <br />

                    {this.props.companySucursales && this.props.companySucursales.length > 0 &&
                    <React.Fragment>
                        <span style={{ fontSize: 18 }}>Sucursales</span>
                        <SwipeableViews
                            index={this.state.index}
                            disabled
                            async
                        >
                            <div>
                                <PagedList
                                    onItemClick={this.handleviewDetails}
                                    items={this.props.companySucursales}
                                    selectPlaceHolder='Regiones'
                                    selectItems={this.props.listaRegion}
                                    itemClick={this.handleSucursalDetails}
                                    pageLimit={6}
                                    pageNeighbours={2}
                                    pageJump={2}
                                    onSelectionChanged={this.handleSelectionChange}
                                />
                            </div>

                            <div>
                                <SucursalDetails
                                    goBack={() => this.setState({ index: 0, selectedSucursal: {} })}
                                    selectedSucursal={this.state.selectedSucursal}
                                />
                            </div>
                        </SwipeableViews>
                    </React.Fragment>}
                </div>
            </div>
        );
    }
}

const normalizeRutCompany = (rolesCompany) => {
    let roles = {};
    const self = {...rolesCompany};
    let entries = Object.entries(self);
    entries.forEach((entry) => {
        if (self.hasOwnProperty(entry[0])) {
            Object.defineProperty(roles, String(entry[0]).toLowerCase(), { value: entry[1]});
        }
    });
    return roles;
};

const isAdmin = (myCompanyRoles, companyId) => {
    const roles = normalizeRutCompany(myCompanyRoles);
    return roles[String(companyId).toLowerCase()]?.includes('Admin')
}

const mapStateToProps = (state) => ({
    isLoading: state.detalleEmpresa.isLoading,
    // UserInfo: state.global.userData,
    companyId: state.global.companyId,
    companyName: state.global.companyName,
    companySucursales: state.global.companySucursales,
    listaEmpresas: state.global.listaEmpresas,
    companyDetails: state.detalleEmpresa.companyDetails,
    listaRegion: state.global.listaRegion,
    isAdmin: isAdmin(state.global.myCompanyRoles, state.global.companyId),
});



const mapDispatchToProps = (dispatch) => ({
    dispatch: (action) => {
        dispatch(action);
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(DatosEmpresa);
